<p-table
  [value]="casesCategories | orderBy: {property: 'name', direction: 1}"
  [scrollable]="true"
  scrollHeight="180px" dataKey="name">
  <ng-template pTemplate="header">
    <tr>
      <th style="max-width:4rem"></th>
      <th class="p-col-4">Name</th>
      <th class="p-col-2">Resolution Days</th>
      <th class="p-col-2" >Is Active</th>
      <th class="p-col-2" >Is Default</th>
      <th class="p-col-2">Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data let-index="rowIndex" let-expanded="expanded">
    <tr>
      <td style="max-width:4rem" class="action" *ngIf="data?.subCategory.length > 0">
        <button type="button" [pRowToggler]="data" pButton pRipple
        class="p-button-text p-button-rounded p-button-plain"
        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td style="max-width:4rem" class="action" *ngIf="data?.subCategory.length == 0">
        
      </td>
      <td class="p-col-4">{{data.name}}</td>
      <td class="p-col-2"></td>
      <td class="p-col-2" >{{data.isActive ? answertypeConstants.Yes : answertypeConstants.No}}</td>
      <td class="p-col-2">
        <p-radioButton
          [value]="true" 
          [(ngModel)]="data.isDefault"
          (onClick)="makeIsDefault(data)"
          [disabled]="!data.isActive || data.isDefault">
        </p-radioButton>
             &nbsp; {{data.isDefault ? answertypeConstants.Yes : answertypeConstants.No}}</td>
      <td class="p-col-2 action">
        <span class="btnBars p-mr-0" (click)="showAddCaseSubData(data)" pTooltip="Add Sub
          Category" tooltipPosition="top"><i class="pi pi-plus"></i></span>
        <span class="btnBars p-mr-0" *ngIf="data.systemGenerated == false" (click)="showEditCaseData(data, caseDataTypes[1])"
          pTooltip="Edit" tooltipPosition="top"><i class="pi
            pi-pencil"></i></span>
        <span class="btnBars p-mr-0" *ngIf="data.systemGenerated == false && !data.isDefault"  (click)="delCategory(data)" pTooltip="Delete"
          tooltipPosition="top"><i class="pi pi-trash"></i></span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-data>
    <tr>
      <td colspan="6" style="padding: 0!important; width: 100%;">
        <p-table [value]="data.subCategory | orderBy: {property: 'subCategory', direction: 1}" dataKey="id">
          <ng-template pTemplate="body" let-sub let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td style="min-width:4rem"></td>
              <td class="p-col-4">{{sub.name}}</td>
              <td class="p-col-2">{{sub.resolutionDays}}</td>
              <td class="p-col-2">{{sub.isActive ? answertypeConstants.Yes : answertypeConstants.No}}</td>
              <td class="p-col-2">
                <p-radioButton *ngIf="sub.organizationId != 0"
                  [value]="true" 
                  [(ngModel)]="sub.isDefault"
                  (onClick)="makeIsDefault(sub)"
                  [disabled]="!sub.isActive || sub.isDefault">
                </p-radioButton>
              &nbsp; {{sub.isDefault ? answertypeConstants.Yes : answertypeConstants.No}}</td>
              <td class="p-col-2">
                <span class="btnBars p-mr-0" *ngIf="sub.organizationId != 0" (click)="showEditCaseSubData(data, sub)" pTooltip="Edit"
                  tooltipPosition="top"><i class="pi
                            pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="sub.organizationId != 0 && !sub.isDefault" (click)="delSubCategory(data, sub)" pTooltip="Delete"
                  tooltipPosition="top"><i class="pi
                            pi-trash"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- <p-dialog
  header="{{addEditCaseSubHeader}}" [modal]="true" [(visible)]="displayAddCaseSubData"
  [style]="{width: '50vw'}" [baseZIndex]="10000">

    <div class="p-grid">
      <div class="p-col-12" *ngIf="addEditCaseSubHeader == 'Add Sub Category Data'">
        <div class="header">
          <h5>Category Name -- {{selectedCategory ? selectedCategory.name : null}}</h5>
        </div>
      </div>
     
      <div class="p-col-12"  *ngIf="addEditCaseSubHeader =='Edit Sub Category Data'">
        <div class="header">
          <h5 class="p-mb-0">Category Name -- {{selectedCategory ? selectedCategory.name : null}}
          <p-inputSwitch  
                          class="header-switch"
                          [(ngModel)]="caseSubCategory.isActive" 
                          [ngModelOptions]="{standalone: true}"
                          [disabled]="caseSubCategory && caseSubCategory?.isDefault">
          </p-inputSwitch>
        </h5>
        </div>
      </div>
    </div>
    
    
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12">
          <label for="name">Name <span style="color: red;">*</span></label>
          <input type="text" 
              pInputText 
              [(ngModel)]="caseSubCategory.name" 
              #dataName="ngModel" 
              required
              (keyup)="onValidateName($event)"
              (blur)="onValidateName($event)"
              [ngClass]="{ 'p-invalid': isDisabledCatName == true}">
          <small *ngIf="isDisabledCatName == true" class="p-invalid">
            Name is required
          </small>
        </div>
        <div class="p-col-12">
          <label for="name">Description</label>
          <input type="text" pInputText style="width: 100%;" [(ngModel)]="caseSubCategory.description">
        </div>
        <div class="p-col-12">
          <label for="name">Resolution Days <span style="color: red;">*</span></label>
          <input type="text" pInputText style="width: 100%;" [(ngModel)]="caseSubCategory.resolutionDays" #resolutionDays="ngModel" required
          [ngClass]="{ 'p-invalid': resolutionDays.invalid && (resolutionDays.touched ||  resolutionDays.dirty)}">
          <small *ngIf="resolutionDays.invalid && (resolutionDays.touched || resolutionDays.dirty)" class="p-invalid">
            Resolution days is required
          </small>
        </div>
        <div class="p-col-6">
          <label>Group <span style="color: red;">*</span></label>
          <p-dropdown 
                  [options]="allUserGroup" 
                  [(ngModel)]="selectedGroup" 
                  placeholder="Select a Group" 
                  optionLabel="name" 
                  appendTo="body" 
                  (onChange)="getUsersList()"
                  #group="ngModel"
                  required>
          </p-dropdown>
          <small *ngIf="group.invalid && (group.touched || group.dirty)" class="p-invalid">
            Group is required
          </small>
        </div>
        <div class="p-col-6">
          <label>Default User</label>
          <p-dropdown 
                  [options]="allUsers" 
                  [(ngModel)]="selectedUser" 
                  placeholder="Select a User" 
                  optionLabel="name" 
                  appendTo="body">
          </p-dropdown>
        </div>
      </div>
    </div>
  <ng-template pTemplate="footer">
    <button pButton (click)="cancelCaseSubDataAdd()" label="Cancel" class="p-button-secondary"></button>
    <button pButton (click)="saveCaseSubDataAdd(caseDataTemp)" label="Save"></button>
  </ng-template>
</p-dialog> -->

<p-dialog
  header="{{addEditCaseSubHeader}}" [modal]="true" [(visible)]="displayAddCaseSubData"
  [style]="{width: '50vw'}" [baseZIndex]="10000">
  <form [formGroup]="subCategoryForm" (ngSubmit)="saveCaseSubDataAdd()" #createSubCategory="ngForm" >
    <div class="p-grid">
      <div class="p-col-12" *ngIf="addEditCaseSubHeader == 'Add Sub Category Data'">
        <div class="header">
          <h5>Category Name -- {{selectedCategory ? selectedCategory.name : null}}</h5>
        </div>
      </div>
     
      <div class="p-col-12"  *ngIf="addEditCaseSubHeader =='Edit Sub Category Data'">
        <div class="header">
          <h5 class="p-mb-0">Category Name -- {{selectedCategory ? selectedCategory.name : null}}
          <p-inputSwitch  
                          class="header-switch"
                          formControlName="isActive"
                          [disabled]="defaultValueCheck">
          </p-inputSwitch>
        </h5>
        </div>
      </div>
    </div>
    
    
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12">
          <label for="name">Name <span style="color: red;">*</span></label>
          <input type="text" 
                pInputText 
                formControlName="name"
                required>
          <small *ngIf="name.invalid && (name.touched || name.dirty)" class="p-invalid">
            <span *ngIf="name.errors?.['required']" class="p-invalid">
              Name is required
            </span>
            <span *ngIf="name.errors?.['pattern']" class="p-invalid">
              Name is not valid
            </span>
          </small>
        </div>
        <div class="p-col-12">
          <label for="name">Description</label>
          <input type="text" pInputText style="width: 100%;" formControlName="description">
        </div>
        <div class="p-col-12">
          <label for="name">Resolution Days <span style="color: red;">*</span></label>
          <input  type="text" 
                  pInputText style="width: 100%;" 
                  formControlName="resolutionDays"
                  required>
          <small *ngIf="resolutionDays.invalid && (resolutionDays.touched || resolutionDays.dirty)" class="p-invalid">
            <span *ngIf="resolutionDays.errors?.['required']" class="p-invalid">
              Resolution days is required
            </span>
            <span *ngIf="resolutionDays.errors?.['pattern']" class="p-invalid">
              Resolution days is not valid
            </span>
          </small>
        </div>
        <div class="p-col-6">
          <label>Group <span style="color: red;">*</span></label>
          <p-dropdown 
                  [options]="allUserGroup" 
                  formControlName="userGroupId"
                  placeholder="Select a Group" 
                  optionLabel="name" 
                  appendTo="body" 
                  (onChange)="getUsersList($event)"
                  required>
          </p-dropdown>
          <small *ngIf="userGroupId.invalid && (userGroupId.touched || userGroupId.dirty)" class="p-invalid">
            <span *ngIf="userGroupId.errors?.['required']" class="p-invalid">
              Group is required
            </span>
          </small>
        </div>
        <div class="p-col-6">
          <label>Default User</label>
          <p-dropdown 
                  [options]="allUsers" 
                  formControlName="defaultUserId"
                  placeholder="Select a User" 
                  optionLabel="name" 
                  appendTo="body">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton (click)="cancelCaseSubDataAdd()" label="Cancel" class="p-button-secondary"></button>
    <button pButton [disabled]="subCategoryForm.invalid" label="Save" (click)="createSubCategory.ngSubmit.emit()"></button>
  </ng-template>
</p-dialog>

<!-- <p-dialog header="Group access permission" [modal]="true" [(visible)]="displayPermission"
  [style]="{width: '50vw'}" [baseZIndex]="10000">
  <div class="header">
    <div class="p-grid">
      <div class="p-col-6">
        <h5 class="p-mb-0">Category: {{selectedCategory?.name}}</h5>
      </div>
      <div class="p-col-6">
        <h5 class="p-mb-0">Sub Category: {{caseSubCategory?.name}}</h5>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="p-grid">
      <div class="p-col-6">
        <label>Group</label>
        <p-dropdown 
                [options]="allUserGroup" 
                [(ngModel)]="selectedGroup" 
                placeholder="Select a Group" 
                optionLabel="name" 
                appendTo="body" 
                (onChange)="getUsersList()"></p-dropdown>
      </div>
      <div class="p-col-6">
        <label>Default User</label>
        <p-multiSelect 
                [options]="allUsers" 
                [(ngModel)]="selectedUser"
                (onChange)="onChangeDefaultUser($event)"
                optionLabel="name" 
                appendTo="body"></p-multiSelect>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton (click)="displayPermission=false" label="Cancel" class="p-button-secondary"></button>
    <button pButton (click)="savaGrpAccessPermission()" label="Save"></button>
  </ng-template>
</p-dialog> -->

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
<!-- [(ngModel)]="selectedUser"
                [ngModelOptions]="{standalone: true}" -->
